import { render, staticRenderFns } from "./PcrDeathCause.vue?vue&type=template&id=0cf82b0c&scoped=true&"
import script from "./PcrDeathCause.vue?vue&type=script&lang=js&"
export * from "./PcrDeathCause.vue?vue&type=script&lang=js&"
import style0 from "./PcrDeathCause.vue?vue&type=style&index=0&id=0cf82b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf82b0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VForm,VIcon,VSpacer,VTextField})
